import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import { throttle } from 'next/javascripts/modules/utils';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/field-prototype-form.scss';
import Sortable from 'sortablejs';

Component('tr-field-prototype-form', {
  mixins: [eventListenerMixin],

  properties: {
    partialUrl: String,
    loading: {
      type: Boolean,
      default: false,
      observer() {
        if (this.loading) {
          this.submitButton.setAttribute('disabled', true);
        } else {
          this.submitButton.removeAttribute('disabled');
        }
      },
    },
  },

  connected() {
    this.initSortableOptions();
  },

  ready() {
    this.fieldType = this.querySelector('.field-prototype-field-type-input tr-combo-select-field');
    this.submitButton = this.querySelector('.mdc-button[type=submit]');

    this.listenTo(
      this.fieldType, 'tr-combo-select-field:change', this.renderFieldOption.bind(this),
    );

    this.listenTo(this, 'click', (event) => {
      const linkAdd = closest(event.target, '.add-option');
      const linkRemove = closest(event.target, '.remove-option');

      if (linkAdd) {
        this.insertSelectFieldOption(linkAdd);
      } else if (linkRemove) {
        closest(linkRemove, '.option').remove();
      }
    });

    this.initNumberOptions();
  },

  initNumberOptions() {
    this.numberOptions = this.querySelector('.number-options');
    if (!this.numberOptions) {
      return;
    }

    const formats = this.numberOptions.querySelector('.field_prototype_options_format_formats');
    const symbol = this.numberOptions.querySelector('.field_prototype_options_format_symbol');
    const position = this.numberOptions.querySelector('.field_prototype_options_format_position');
    const decimals = this.numberOptions.querySelector('.field_prototype_options_format_decimals');
    const preview = this.numberOptions.querySelector('.preview');

    const formatsField = formats.querySelector('tr-combo-select-field');
    const decimalsField = decimals.querySelector('tr-combo-select-field');
    const symbolField = symbol.querySelector('tr-text-field');
    const positionField = position.querySelector('tr-combo-select-field');

    const format = () => {
      preview.formats = formatsField.getValue();
      preview.decimals = decimalsField.getValue();
      preview.symbol = symbolField.getValue();
      preview.position = positionField.getValue();
      preview.format();
    };

    if (formatsField.getValue() === 'percent') {
      preview.num = 100;
    }
    format();

    this.listenTo(this.numberOptions, 'tr-combo-select-field:change', (e) => {
      if (e.target === formatsField) {
        if (e.detail === 'none') {
          symbol.classList.add('hidden');
          position.classList.add('hidden');
          decimals.classList.add('hidden');
        } else {
          symbol.classList.toggle('hidden', e.detail !== 'custom');
          position.classList.toggle('hidden', e.detail !== 'custom');
          if (e.detail === 'custom') {
            symbolField.layout();
            positionField.layout();
          }
          decimals.classList.remove('hidden');
          decimalsField.layout();
        }
        if (e.detail === 'percent') {
          preview.num = 100;
          decimalsField.setValue('0');
        } else {
          preview.num = 1000;
          decimalsField.setValue('2');
        }
      }
      format();
    });

    this.listenTo(symbolField, 'input', throttle(() => {
      format();
    }, 100));
  },

  initSortableOptions() {
    const select = Array.from(this.querySelectorAll('.select-options'));
    this.optionSortableInstances = select.map(sel => Sortable.create(sel, {
      group: 'select-option',
      sort: true,
      draggable: '.option',
      handle: '.drag-handle',
      animation: 0,
      forceFallback: (window.gon && window.gon.sortableFallback) || false,
      onEnd: () => {
        sel.querySelectorAll('.option').forEach((opt, i) => {
          opt.querySelectorAll('input').forEach((input) => {
            // eslint-disable-next-line no-param-reassign
            input.name = input.name.replace(/\[\d+\]/, `[${i}]`);
          });
        });
      },
    }));
  },

  renderFieldOption() {
    this.loading = true;
    $.ajax({
      url: this.partialUrl,
      type: 'get',
      dataType: 'script',
      data: {
        field_type: this.fieldType.getValue(),
      },
      complete: () => {
        this.loading = false;
        setTimeout(() => {
          this.initSortableOptions();
          this.initNumberOptions();
        }, 10);
      },
    });
  },

  insertSelectFieldOption(linkAdd) {
    let newOptionIndex = 0;
    const lastOption = [...this.querySelectorAll('.option')].pop();
    if (lastOption) {
      const [, lastOptionIndex] = lastOption.querySelector('input').name.match(/\[(\d+)\]/);
      newOptionIndex = parseInt(lastOptionIndex, 10) + 1;
    }

    const { template } = linkAdd.dataset;
    linkAdd.insertAdjacentHTML(
      'beforebegin',
      template.replace(/\[(_new_option_)\]/g, () => `[${newOptionIndex}]`),
    );

    const color = this.pickRandomColor();
    setTimeout(() => {
      [...this.querySelectorAll('tr-color-select-field')].pop().selectColor(color);
    });
  },

  pickRandomColor() {
    const colors = ['grey', 'brown', 'red', 'orange', 'pink', 'violet', 'purple', 'navy', 'blue', 'teal', 'green', 'yellowgreen'];
    const selectedColors = [...document.querySelectorAll('tr-color-select-field')].map(node => node.value);
    const unselectedColors = colors.filter(color => selectedColors.indexOf(color) !== -1);
    if (unselectedColors.length > 0) {
      return unselectedColors[0];
    }
    return colors[parseInt(Math.random() * 12, 10)];
  },

  disconnected() {
    this.stopListening();
    this.optionSortableInstances.forEach(item => item.destroy());
  },
});
